import { render } from "./ObjectImageComponent.vue?vue&type=template&id=f094f322&scoped=true"
import script from "./ObjectImageComponent.vue?vue&type=script&lang=js"
export * from "./ObjectImageComponent.vue?vue&type=script&lang=js"

import "./ObjectImageComponent.vue?vue&type=style&index=0&id=f094f322&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f094f322"]])

export default __exports__